const MENU = {
  "owner": [{
    "title": "Pénzügyi statisztikák",
    "items": []
  },{
    "title": "Könyvstatisztikák",
    "items": []
  },
  {
    "title": "Összesített statisztikák",
    "items": [{
      "title": "Összesített könyvstatisztika",
      "slug": "/owners/royalty-books/summary"
    },{
      "title": "Összesített jogdíj export",
      "slug": "/owners/finance/summary"
    },
      {
        "title": "Könyv gyártási megtérülés",
        "slug": "/owners/finance/books-manufacturing-return"
      }
    ]
  }],
  "influencer": [
    {
      "title": "Havi jutalékok",
      "items": []
    },
    {
      "title": "Ajánlásommal regisztráltak",
      "items": [
        {
          "title": "Kuponos előfizetők",
          "slug": "/affiliates/users/continuous"
        },
        {
          "title": "Affiliate jutalék",
          "slug": "/affiliates/users/onetime"
        }
      ]
    },
    {
      "title": "Értékesítés",
      "items": [
      {
        "title": "Kódgenerálás (Rendszerhasználati díj)",
        "slug": "/affiliates/sell/book?purchaseType=ROYALTY_FREE"
      },
      {
        "title": "Kódgenerálás (Viszonteladói díj)",
        "slug": "/affiliates/sell/book?purchaseType=ROYALTIES_INCLUDED"
      },
      {
        "title": "Eladott könyvek",
        "slug": "/affiliates/sell/sold"
      },
      {
        "title": "Eladott előfizetések",
        "slug": "/affiliates/sell/sold-subscriptions"
      },
      {
        "title": "Kuponkódjaim",
        "slug": "/affiliates/campaigns/codes"
      },
      {
        "title": "Affiliate linkek",
        "slug": "/affiliates/campaigns/links"
      }
    ]
    },
    {
      "title": "Beállítások",
      "items": [{
        "title": "Bankkátya beállítás",
        "slug": "/settings/bankcard"
      }
    ]
    }
  ]
}

export default MENU
